import { render, staticRenderFns } from "./RouteForm.vue?vue&type=template&id=31c982a2&scoped=true&"
import script from "./RouteForm.vue?vue&type=script&lang=js&"
export * from "./RouteForm.vue?vue&type=script&lang=js&"
import style0 from "./RouteForm.vue?vue&type=style&index=0&id=31c982a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c982a2",
  null
  
)

export default component.exports